<template>
  <div class="product">
    <div class="header-box">
      <layoutHeader :default-bg="'rgba(0,0,0,0.3)'"/>
    </div>

    <div class="content">
      <div class="title">
        <div class="name">数显终端</div>
        <div class="en-name">DIGITAL DISPLAY TERMINAL</div>
        <div class="btn-list">
          <template v-for="(item, index) in tabList">
            <div class="item" :class="index === currentIndex ? 'active':''" @click="onTabChange(index)" :key="index">
              {{ item.productName }}
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="info-content">

      <div class="main-container">
        <div class="info" v-if="tabList.length > 0" v-html="tabList[currentIndex].productInfo"></div>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import model from '@/model/product'

export default {
  components: {
    layoutHeader,
  },
  name: 'layout',
  data() {
    return {
      currentIndex: 0,
      tabList: []
    }
  },
  created() {
    this.getProduct()
  },
  mounted() {
  },
  methods: {
    onTabChange(index) {
      this.currentIndex = index
    },
    async getProduct() {
      const res = await model.getWebsiteProductList(2)
      if (res.code === 1) {
        this.tabList = res.data
      }
    }
  }
}
</script>

<style lang="scss">
.product {
  .content {
    .main-container {
      .info {
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.product {
  background: #141414;
  min-height: 100vh;
  background-size: cover;

  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }


  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;
    background: url('https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/product_bg.png') no-repeat center center;
    background-size: cover;

    .title {
      width: 100%;
      height: 720px;
      color: #fff;
      padding-top: 204px;
      text-align: left;
      padding-left: 200px;
      box-sizing: border-box;

      .name {
        font-size: 141px;
        font-weight: 500;
        line-height: 165px;
        list-style-image: linear-gradient(180deg, #FFFFFF 6%, rgba(255, 255, 255, 0) 100%);
      }

      .en-name {
        font-size: 39px;
        font-weight: 500;
        line-height: 46px;
        list-style-image: linear-gradient(180deg, #FFFFFF 6%, rgba(255, 255, 255, 0) 100%);
      }

      .btn-list {
        display: flex;
        align-items: center;
        margin-top: 95px;

        .item {
          cursor: pointer;
          font-size: 22px;
          font-weight: 500;
          line-height: 26px;
          border-radius: 4px;
          border: 1px solid #FFFFFF;
          margin-right: 30px;
          padding: 9px 20px;
        }

        .active {
          background: #EB6100;
          border-color: #EB6100;
        }
      }
    }
  }

  .info-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    background: #0A0A14;

    .info {
      text-align: center;
    }
  }
}
</style>

<style>
.info-content .info img{
  max-width: 100%;
}
</style>
